<template>
  <div class="flex flex-col h-min-screen justify-center text-center fixed z-50 w-full h-full bg-opacity-70 bg-black -translate-x-1/2 left-1/2 -translate-y-1/2 top-1/2">
    <div class="relative mx-auto px-8 py-4 bg-white text-background-secondary w-full md:w-1/2">
      <button @click="$emit('closeAIPopup')" class="absolute right-0 mx-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide-icon lucide lucide-x h-4 w-4">
          <path d="M18 6 6 18"></path>
          <path d="m6 6 12 12"></path>
        </svg>
      </button>
      <div class="flex justify-center"><img src="@/assets/images/genAIForSolidify/AI-Assist-Activated-1.gif" /></div>
      <div class="flex justify-center items-center pt-2 font-bold">
        <div><img src="@/assets/images/genAIForSolidify/AI-Assist-Activated-star.jpg" /></div>
        <strong class="text-background-tertiary text-xl pl-2 pr-2">AI Assist Activated!</strong>
        <div><img src="@/assets/images/genAIForSolidify/alert-new-feature-2.jpg" /></div>
      </div>
      <div class="pt-2 text-left">
        <div class="pt-1">Your submission is being reviewed for <strong>relevance, clarity, and completeness</strong>. Get instant insights to refine your work!</div>
        <div class="pt-2 text-background-tertiary font-bold text-left">How It Works:</div>
        <ul class="pt-1 list-disc pl-5">
          <li class="pt-1 !text-background-secondary">AI provides feedback based on task objectives.</li>
          <li class="pt-1 !text-background-secondary">You can <strong>revise your submission or proceed to peer review</strong></li>
        </ul>
      </div>
      <div class="pt-2 italic text-left">
        <div><span class="text-background-tertiary">Disclaimer:</span> AI-generated feedback is a guidance tool and may have its own biases.</div>
      </div>
      <div class="flex justify-center items-center pt-2 font-bold">
        <div><img src="@/assets/images/genAIForSolidify/AI-Assist-Activated-cup.jpg" /></div>
        <div class="text-background-tertiary text-xl pl-2 pr-2 italic">
          Attempts Left: [{{ stat?.taskDetails?.genAiAssistMaxAttempts - stat?.genAiAssistDetails?.length - 1 }}/{{ stat?.taskDetails?.genAiAssistMaxAttempts }}] - Make the most of it!
        </div>
        <div><img src="@/assets/images/genAIForSolidify/AI-Assist-Activated-circle.jpg" /></div>
      </div>
      <div class="flex items-center justify-start py-4 space-y-4 text-left">
        <img class="block h-6 w-6 mr-1" src="@/assets/images/loadernew.gif" alt="Loader Gif" />
        <p class="text-gray-600 text-sm whitespace-pre-wrap text-left">
          {{ typedMessage }}
          <span v-if="showCursor" class="animate-blink">|</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue';
export default defineComponent({
  name: 'AILoader',
  props: {
    stat: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const messages = ['Thinking deeply...', 'Analyzing context...', 'Generating insights...', 'Polishing response...', 'Finalizing thoughts...'];

    const typedMessage = ref('');
    const showCursor = ref(true);

    let currentMessageIndex = 0;
    let currentCharIndex = 0;

    function typeNextChar() {
      const message = messages[currentMessageIndex];

      if (currentCharIndex < message.length) {
        typedMessage.value += message[currentCharIndex++];
        setTimeout(typeNextChar, 50);
      } else {
        // Pause before next message
        setTimeout(() => {
          currentMessageIndex = (currentMessageIndex + 1) % messages.length;
          currentCharIndex = 0;
          typedMessage.value = '';
          typeNextChar();
        }, 3000);
      }
    }

    onMounted(() => {
      typeNextChar();
      setInterval(() => {
        showCursor.value = !showCursor.value;
      }, 500);
    });
    return { typedMessage, showCursor };
  },
});
</script>

<style scoped>
.animate-blink {
  animation: blink 1s step-start infinite;
}
@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
</style>
